import { render, staticRenderFns } from "./DetachableTrailers.vue?vue&type=template&id=4d3a46ce&scoped=true&"
import script from "./DetachableTrailers.vue?vue&type=script&lang=js&"
export * from "./DetachableTrailers.vue?vue&type=script&lang=js&"
import style0 from "./DetachableTrailers.vue?vue&type=style&index=0&id=4d3a46ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a46ce",
  null
  
)

export default component.exports